import { render, staticRenderFns } from "./SummaryProjection.vue?vue&type=template&id=04e07835"
import script from "./SummaryProjection.vue?vue&type=script&lang=js"
export * from "./SummaryProjection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports